import Vue from "vue";

Vue.filter('money', function (value) {
    if (!value) return 0;
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
});
Vue.filter('card', function (value) {
    if (!value) return 0;
    return value.toString().replace(/\B(?=(\d{4})+(?!\d))/g, "-")
});